module.exports = __webpack_public_path__ + "img/buddy_whiskers-04.26aca4c8.svg";